import { FC, useState } from 'react';
import { Typography, Stack, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Collapse } from '@mui/material';
import { PictureAsPdf, Audiotrack, OndemandVideo, Link as LinkIcon, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';


const resourceIcons: Record<Programs.ResourceType, typeof PictureAsPdf> = {
  pdf: PictureAsPdf,
  audio: Audiotrack,
  video: OndemandVideo,
  link: LinkIcon,
};

interface Props {
  resources: Programs.ProgramStepResource[];
}

export const StepResources: FC<Props> = ({ resources }) => {
  const [show, setShow] = useState(false);

  if (resources.length === 0) return null;

  const toggleShow = () => {
    setShow(!show);
  };

  return (
    <Stack spacing={1}>
      <Typography sx={{ cursor: 'pointer' }} display="flex" alignItems="center" justifyContent="center" variant="overline" color="primary" onClick={toggleShow}>
        Resources
        {show ? <KeyboardArrowUp fontSize="small"/> : <KeyboardArrowDown fontSize="small"/>}
      </Typography>
      <Collapse in={show}>
        <List disablePadding>
          {resources.map(resource => {
            const Icon = resourceIcons[resource.resourceType];
            const href = resource.url || resource.file || '#';

            return (
              <ListItem key={resource.id} disablePadding sx={{ border: '1px solid #365863', borderRadius: '12px', mb: 1 }}>
                <ListItemButton
                  component="a"
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ py: 0.5, px: 1, borderRadius: '12px' }}
                >
                  <ListItemIcon sx={{ minWidth: 0, px: 0.5 }}>
                    <Icon/>
                  </ListItemIcon>
                  <ListItemText
                    sx={{
                      '.MuiTypography-root': {
                        fontSize: '14px',
                      },
                    }}
                    primary={resource.title}/>
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Collapse>
    </Stack>
  );
};
